import { FC, ReactNode } from 'react';

import { Container } from './styles';

const DEFAULT_ZINDEX = 10000000;

interface IBackdrop {
  onClose: Function;
  children: ReactNode;
  zIndex?: number;
  top?: number;
}

const Backdrop: FC<IBackdrop> = ({ onClose, children, zIndex = DEFAULT_ZINDEX, top = 0 }) => (
  <Container onClick={() => onClose()} zIndex={zIndex} top={top}>
    {children}
  </Container>
);

Backdrop.defaultProps = {
  zIndex: DEFAULT_ZINDEX,
};

export default Backdrop;
